(() => {
  const readFeatureRatingStars = () => {
    const isRatingStarsEnabled = window._growthbook.getFeatureValue(
      "PLP-Star-Rating",
      false,
    );

    const isHoldoutGroupEnablet = window._growthbook.getFeatureValue(
      "holdout-pdm-the-meatery",
      "OFF",
    );

    const cards = document.querySelectorAll('.product-card .jdgm-widget.jdgm-preview-badge');

    if (!isRatingStarsEnabled || isHoldoutGroupEnablet === "holdout-q4-2025") {
      cards.forEach(card => {
        card.classList.remove('active');
      });
      return;
    }

    if (isRatingStarsEnabled) {
      cards.forEach(card => {
        card.classList.add('active');
      });
    }
  };

  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push((gb) => {
    const applyFeatureFlags = () => {
      readFeatureRatingStars();
    };

    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
})();